import { z } from 'zod';

// Aceita com ou sem máscara. Front aplica `stripDocumentoMask` antes de submeter
// (BFF também tolera, mas mandar limpo evita ambiguidade).
const CPF_RE = /^\d{11}$|^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
const CNPJ_RE = /^\d{14}$|^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;

export const clientInputSchema = z
  .object({
    nome: z.string().trim().min(1, 'Obrigatório').max(150, 'Máximo 150 caracteres'),
    tipoPessoa: z.enum(['PF', 'PJ'], { required_error: 'Obrigatório' }),
    documento: z.string().trim().min(1, 'Obrigatório'),
    telefone: z.string().trim().min(1, 'Obrigatório').max(20, 'Máximo 20 caracteres'),
    contato: z.string().trim().min(1, 'Obrigatório').max(150, 'Máximo 150 caracteres'),
    endereco: z.string().trim().max(500, 'Máximo 500 caracteres').nullable().optional(),
    enderecoComercialId: z.number().int().positive().nullable().optional(),
    enderecoFaturamentoId: z.number().int().positive().nullable().optional(),
    enderecoCorrespondenciaId: z.number().int().positive().nullable().optional(),
    ativo: z.boolean().optional(),
  })
  .superRefine((data, ctx) => {
    const re = data.tipoPessoa === 'PF' ? CPF_RE : CNPJ_RE;
    if (!re.test(data.documento)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['documento'],
        message:
          data.tipoPessoa === 'PF'
            ? 'CPF inválido. Use 11 dígitos.'
            : 'CNPJ inválido. Use 14 dígitos.',
      });
    }
  });

export type ClientFormValues = z.infer<typeof clientInputSchema>;
